import React, { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import "../../login-form/LoginForm.css";
import { Center } from "@/shared/components/center/Center";
import { Stack } from "@/shared/components/stack/Stack";
import { AxiosError } from "axios";
import { storage } from "@/shared/utils";
import { Logo } from "../logo/Logo";
import { forgotPassword } from "../../api/login";
import { toast } from "sonner";

export const ForgotPassword = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    const formData = new FormData(e.currentTarget);
    const email = formData.get("email") as string;

    try {
      const response = await forgotPassword({
        email,
      });
      toast.success("Пароль отправлен на почту");
      navigate("/login");
    } catch (err) {
      if (err instanceof Error) {
        const errorMessage =
        err.message
        setError(errorMessage);
      } else {
        setError("Произошла неизвестная ошибка");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="pageContainer">
      <Center>
        <div className="loginCard">
          <Stack gap={"32px"}>
            <Center>
              <Stack gap={"24px"} style={{ textAlign: "center" }}>
                <Logo />
                <h1 className="title">Восстановление пароля</h1>
              </Stack>
            </Center>
            <form onSubmit={handleSubmit} className="form">
              <Stack gap={"24px"}>
                <Stack gap={"16px"}>
                  <label className="field">
                    <span className="labelText">Email</span>
                    <input
                      type="email"
                      name="email"
                      placeholder="Email"
                      className="input"
                      required
                    />
                  </label>
                </Stack>

                {error && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "center",
                    }}
                  >
                    {error}
                  </div>
                )}

                <Stack gap={"12px"}>
                  <button
                    type="submit"
                    className="submitButton"
                    disabled={isLoading}
                  >
                    Оправить пароль на почту
                  </button>
                </Stack>
              </Stack>
            </form>
          </Stack>
        </div>
      </Center>
    </div>
  );
};
